export default __webpack_public_path__ + "static/media/72.7f19399a.png";